import React, {useCallback, useState} from "react";
import RestClientInstance from "../../../../lib/RestClient";
import i18n from "../../../../locale/i18n";
import {Button, Form, Grid, Input} from "semantic-ui-react";

interface MailBoxAuthSetNewPinProps {
  onSuccess(): void;
  onCancel(): void;
}

const t = i18n.t.bind(i18n);

function MailBoxAuthSetNewPin(props: MailBoxAuthSetNewPinProps) {
  const { onSuccess, onCancel } = props;

  const [settingNewPin, setSettingNewPin] = useState<boolean>(false);
  const [resetCodeInput, setResetCodeInput] = useState<string>('');
  const [newPinInput, setNewPinInput] = useState<string>('');
  const [newPinRepeatInput, setNewPinRepeatInput] = useState<string>('');
  const [setPinError, setSetPinError] = useState<string>('');
  const pinPattern = /^[0-9]+$/;

  const pinRequirementsError = newPinRepeatInput.length > 0 && (newPinInput.length < 6 || !pinPattern.test(newPinInput));
  const pinRepeatError = !pinRequirementsError && newPinRepeatInput.length === newPinInput.length && newPinRepeatInput.length > 0 && newPinRepeatInput !== newPinInput;

  const newPinFormInvalid = (() => {
    if(newPinInput.length !== 6 || newPinRepeatInput.length !== 6 || resetCodeInput.length !== 6) {
      return true;
    }
    if(!pinPattern.test(newPinInput) || !pinPattern.test(newPinRepeatInput) || !pinPattern.test(resetCodeInput)) {
      return true;
    }
    if(newPinInput !== newPinRepeatInput) {
      return true;
    }
    return false;
  })();
  const setNewPin = useCallback(() => {
    if(settingNewPin || newPinFormInvalid) {
      return;
    }
    setSettingNewPin(true);
    setSetPinError('');
    RestClientInstance.post('mailbox/auth/set-pin', {
        oneTimeCode: resetCodeInput,
        newPin: newPinInput
      })
      .then(response => {
        if(response.data.success) {
          onSuccess();
        } else {
          setSettingNewPin(false);
          setResetCodeInput('');
          setNewPinInput('');
          setNewPinRepeatInput('');
          let errorMessage = 'Error: ' + response.data.message;
          switch(response.data.message) {
            case 'too_many_tries':
              errorMessage = t('MailBox.Auth.Reset.Error.TooManyTries');
              break;
            case 'invalid_code':
              errorMessage = t('MailBox.Auth.Reset.Error.InvalidCode');
              if(response.data.triesRemaining) {
                errorMessage += ' ' + t('MailBox.Auth.Reset.Error.InvalidCodeRemainingTries', { triesRemaining: response.data.triesRemaining});
              }
              break;
            case 'reset_not_requested':
              errorMessage = t('MailBox.Auth.Reset.Error.ResetNotRequested');
              break;
            default:
          }

          setSetPinError(errorMessage);
        }
      }).catch(error => {
      setSettingNewPin(false);
    });
  }, [settingNewPin, newPinFormInvalid, onSuccess, resetCodeInput, newPinInput]);

  return <div>
    <p>{t('MailBox.Auth.Reset.SetNewPinParagraph1')}</p>
    <p>{t('MailBox.Auth.Reset.SetNewPinParagraph2')}</p>
    <Grid>
      <Grid.Row>
        <Grid.Column mobile="16" computer="6">
          <Form onSubmit={() => setNewPin()}>
            <Form.Field>
              <label>{t('MailBox.Auth.Reset.InputOneTimeCodeLabel')}</label>
              <Input type="password" pattern="[0-9]{6}" minLength={6} maxLength={6} inputMode="numeric" name="reset_code"
                     autoComplete="one-time-code"
                     value={resetCodeInput}
                     disabled={settingNewPin}
                     onChange={(ev,data) => setResetCodeInput(data.value)}
                     icon="mail" />
            </Form.Field>
            <Form.Field error={pinRequirementsError}>
              <label>{t('MailBox.Auth.Reset.InputNewPinLabel')}</label>
              <Input type="password" pattern="[0-9]{6}" minLength={6} maxLength={6} inputMode="numeric" name="new_pin"
                     autoComplete="one-time-code"
                     value={newPinInput}
                     disabled={settingNewPin}
                     onChange={(ev,data) => setNewPinInput(data.value)}
                     icon="lock" />
            </Form.Field>
            {pinRequirementsError && <p className="" style={{color: '#89220a'}}>
              {t('MailBox.Auth.Reset.InputNewPinErrorRequirements')}
            </p>}

            <Form.Field error={pinRepeatError}>
              <label>{t('MailBox.Auth.Reset.InputNewPinRepeatLabel')}</label>
              <Input type="password" pattern="[0-9]{6}" minLength={6} maxLength={6} inputMode="numeric" name="repeat_pin"
                     autoComplete="one-time-code"
                     value={newPinRepeatInput}
                     disabled={settingNewPin}
                     onChange={(ev,data) => setNewPinRepeatInput(data.value)}
                     icon="lock" />
            </Form.Field>
            {pinRepeatError && <p className="" style={{color: '#89220a'}}>
              {t('MailBox.Auth.Reset.InputNewPinRepeatErrorNotMatching')}
            </p>}


            <p className="" style={{color: '#89220a'}}>
              {setPinError || <>&nbsp;</>}
            </p>

            <Button disabled={newPinFormInvalid}
                    loading={settingNewPin}
                    type="submit"
                    primary>
              {t('MailBox.Auth.Reset.ButtonSaveNewPin')}
            </Button>
            <Button type="button" disabled={settingNewPin}
                    onClick={onCancel}>
              {t('Common.Cancel')}
            </Button>
          </Form>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>;
}

export default MailBoxAuthSetNewPin;